import { useReducer } from 'react';
import axios from 'axios';

import { configs } from '../constants/configs/configs';

const actions = {
    GET_ANNOUNCEMENTS: 'GET_ANNOUNCEMENTS'
};

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'csrftoken': window.csrf_token
    }
});

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: payload
            };
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        announcements: undefined
    });
    const { endpoints } = configs;

    const getAnnouncements = async () => {
        try {
            const res = await api.get(endpoints.ANNOUNCEMENTS);
            let updatedAnnouncements = [];
            if (res && res.data) {
                updatedAnnouncements = res.data.map(i => {
                    let text = i.announcementText.replace('<p>', '');
                    text = text.replace('</p>', '');
                    return {
                        ...i,
                        announcementText: text
                    };
                });
            }
            dispatch({ type: actions.GET_ANNOUNCEMENTS, payload: updatedAnnouncements });
        } catch (e) {
            console.log(`Request to ${endpoints.ANNOUNCEMENTS} failed`);
            dispatch({ type: actions.GET_ANNOUNCEMENTS, payload: [] });
        }
    };

    return {
        ...data,
        getAnnouncements: () => {
            getAnnouncements();
        }
    };
};